import { createAsyncTypes } from 'store/utils';

// State Key
export const KEY = 'auth';

// Action Types
export const types = {
  ADMIN_LOGIN_ASYNC: createAsyncTypes(`${KEY}/ADMIN_LOGIN_ASYNC`),
  ADMIN_PIN_VALIDATION_ASYNC: createAsyncTypes(`${KEY}/ADMIN_PIN_VALIDATION_ASYNC`),
  MAINTENANCE_LOGIN_ASYNC: createAsyncTypes(`${KEY}/MAINTENANCE_LOGIN_ASYNC`),
  DEMO_LOGIN_ASYNC: createAsyncTypes(`${KEY}/DEMO_LOGIN_ASYNC`),
  REMOVE_MAINTENANCE_TOKEN: `${KEY}/REMOVE_MAINTENANCE_TOKEN`,
  REMOVE_ADMIN_TOKEN: `${KEY}/REMOVE_ADMIN_TOKEN`,
  RESET_MAINTENANCE_MESSAGE: `${KEY}/RESET_MAINTENANCE_MESSAGE`,
  RESET_ADMIN_MESSAGE: `${KEY}/RESET_ADMIN_MESSAGE`,
  RESET_ADMIN_PIN_MESSAGE: `${KEY}/RESET_ADMIN_PIN_MESSAGE`,
  RESET_ADMIN_PIN_AUTHORIZED: `${KEY}/RESET_ADMIN_PIN_AUTHORIZED`
};

export interface DecodedJWT {
  adminId: string;
  scopes: string[];
  iat: number;
  exp: number;
}

export interface AuthState {
  readonly admin: DecodedJWT | object;
  readonly maintenance: DecodedJWT | object;
  readonly adminPinAuthorized: boolean;
  readonly loading: boolean;
  readonly adminError: undefined | string;
  readonly maintenanceError: undefined | string;
  readonly adminPinError: undefined | string;
}

export interface AdminLoginRequest {
  type: typeof types.ADMIN_LOGIN_ASYNC.REQUEST;
  payload: {
    email: string;
    password: string;
  };
}

export interface AdminLoginError {
  type: typeof types.ADMIN_LOGIN_ASYNC.ERROR;
  payload: string;
}

export interface AdminLoginPending {
  type: typeof types.ADMIN_LOGIN_ASYNC.PENDING;
  payload: boolean;
}

export interface AdminLoginSuccess {
  type: typeof types.ADMIN_LOGIN_ASYNC.SUCCESS;
  payload: DecodedJWT;
}

export interface AdminPinValidationRequest {
  type: typeof types.ADMIN_PIN_VALIDATION_ASYNC.REQUEST;
  payload: { pinCode: string };
}

export interface AdminPinValidationError {
  type: typeof types.ADMIN_PIN_VALIDATION_ASYNC.ERROR;
  payload: string;
}

export interface AdminPinValidationPending {
  type: typeof types.ADMIN_PIN_VALIDATION_ASYNC.PENDING;
  payload: boolean;
}

export interface AdminPinValidationSuccess {
  type: typeof types.ADMIN_PIN_VALIDATION_ASYNC.SUCCESS;
}

export interface MaintenanceLoginRequest {
  type: typeof types.MAINTENANCE_LOGIN_ASYNC.REQUEST;
  payload: { pinCode: string };
}

export interface MaintenanceLoginError {
  type: typeof types.MAINTENANCE_LOGIN_ASYNC.ERROR;
  payload: string;
}

export interface MaintenanceLoginPending {
  type: typeof types.MAINTENANCE_LOGIN_ASYNC.PENDING;
  payload: boolean;
}

export interface MaintenanceLoginSuccess {
  type: typeof types.MAINTENANCE_LOGIN_ASYNC.SUCCESS;
  payload: DecodedJWT;
}

export interface RemoveMaintenanceToken {
  type: typeof types.REMOVE_MAINTENANCE_TOKEN;
}

export interface RemoveAdminToken {
  type: typeof types.REMOVE_ADMIN_TOKEN;
}

export interface ResetMaintenanceMessage {
  type: typeof types.RESET_MAINTENANCE_MESSAGE;
}

export interface ResetAdminMessage {
  type: typeof types.RESET_ADMIN_MESSAGE;
}

export interface ResetAdminPinMessage {
  type: typeof types.RESET_ADMIN_PIN_MESSAGE;
}

export interface ResetAdminPinAuthorized {
  type: typeof types.RESET_ADMIN_PIN_AUTHORIZED;
}

export interface DemoLoginRequest {
  type: typeof types.DEMO_LOGIN_ASYNC.REQUEST;
  payload: {
    kioskId: string;
    adminId: string;
  };
}

export interface DemoLoginError {
  type: typeof types.DEMO_LOGIN_ASYNC.ERROR;
  payload: string;
}

export interface DemoLoginPending {
  type: typeof types.DEMO_LOGIN_ASYNC.PENDING;
  payload: boolean;
}

export interface DemoLoginSuccess {
  type: typeof types.DEMO_LOGIN_ASYNC.SUCCESS;
  payload: DecodedJWT;
}

export type AuthActionTypes =
  | AdminLoginRequest
  | AdminLoginError
  | AdminLoginPending
  | AdminLoginSuccess
  | AdminPinValidationRequest
  | AdminPinValidationError
  | AdminPinValidationPending
  | AdminPinValidationSuccess
  | MaintenanceLoginRequest
  | MaintenanceLoginError
  | MaintenanceLoginPending
  | MaintenanceLoginSuccess
  | RemoveMaintenanceToken
  | RemoveAdminToken
  | ResetMaintenanceMessage
  | ResetAdminMessage
  | ResetAdminPinMessage
  | ResetAdminPinAuthorized
  | DemoLoginRequest
  | DemoLoginError
  | DemoLoginPending
  | DemoLoginSuccess;
